import { render, staticRenderFns } from "./CompanySmallCard.vue?vue&type=template&id=db5381fa&scoped=true&"
import script from "./CompanySmallCard.vue?vue&type=script&lang=js&"
export * from "./CompanySmallCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanySmallCard.vue?vue&type=style&index=0&id=db5381fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5381fa",
  null
  
)

/* custom blocks */
import block0 from "./CompanySmallCard.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CompanySmallCard.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VIcon,VTab,VTabs})
